export default {
  key1: 'this is message1', // basic
  nested: {
    // nested
    message1: 'this is nested message1',
  },
};
